import moment from 'moment';
import http from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_DATA(state, data) { state.data = data; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        dateFrom: filters.dateFrom ? moment.utc(filters.dateFrom).unix() : undefined,
        dateTo: filters.dateTo ? moment.utc(filters.dateTo).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit }, data) {
      const response = await http.get('v1/user/api-keys', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { apiKeyList, pages } = response.data;
      commit('SET_DATA', apiKeyList);
      if (pages) {
        commit('SET_PAGES', pages);
      }
    },

    async updateApiKey(__store, data) {
      const response = await http.put('v1/user/api-keys', data);
      return response.data;
    },
  },

  namespaced: true,
});
